import { Pipe, PipeTransform, inject } from '@angular/core';
import { Employee, EmptyGuid } from '@coin/shared/core/util-models';
import { Observable, of } from 'rxjs';
import { MeritAllocationGeneralService } from '../../merit/merit-shared/services/merit-allocation-general.service';

@Pipe({ name: 'meritEmployeeSnapshotId$' })
export class MeritSnapshotIdPipe implements PipeTransform {
  private readonly meritAllocationGeneralService = inject(MeritAllocationGeneralService);

  transform(employeeId: string, seasonId: string): Observable<Employee> {
    if (employeeId && seasonId && employeeId !== EmptyGuid) {
      return this.meritAllocationGeneralService.getEmployeeSnapshotById(seasonId, employeeId);
    }
    return of(null);
  }
}
